<template>
  <div class="utente">
    <b-row>
      <b-col class="mt-3">
        <h5><b>Rinnova abbonamento utente</b></h5><br />        
      </b-col>
    </b-row>

    <b>Nome:</b> {{utente.nome}} <br/>
    <b>Cognome:</b> {{utente.cognome}} <br/>
    <b>PEC:</b> {{utente.pec}} <br/>
    <b>Email utente:</b> {{utente.emailUtente}} <br/>    
    <b>Data scadenza:</b> <b>{{utente.dataScadenza}}</b> <br/>
    <b>Fattura da emettere:</b> <b>{{utente.fatturaDaEmettere}}</b> <br/>
    <br/>

    <b-button @click="rinnova()" variant="success">Aggiorna scadenza tra 1 anno</b-button>
    <br/><br/>
    <form action="https://www.enotula.it/giustup.php" method="post">
      <input type="radio" style="display:none" checked="checked" name="tipoAbbonamento" value="GiustUp.it">
      <input type="hidden" name="username" :value="utente.codFisc">
      <input type="hidden" name="denominazione" :value="utente.denominazione">
      <input type="hidden" name="indirizzo" :value="utente.indirizzo">
      <input type="hidden" name="civico" value="">
      <input type="hidden" name="citta" :value="utente.citta">
      <input type="hidden" name="cap" :value="utente.cap">
      <input type="hidden" name="provincia" :value="utente.provincia">
      <input type="hidden" name="emailCliente" :value="utente.emailPagante">
      <input type="hidden" name="codiceFiscale" :value="utente.codFiscPagante">
      <input type="hidden" name="partitaIva" :value="utente.piva">
      <input type="hidden" name="codiceUfficio" :value="utente.codiceUfficio">
      <input type="hidden" name="rivistaNome" value="www.giustup.it">
      <input type="hidden" name="scadenzaAbbonamento" :value="utente.dataScadenza">
      <input type="hidden" name="username" value="CNS">
      <input type="hidden" name="password" value="CNS">
      <input type="hidden" name="split" value="0">
      <input type="hidden" name="sender" value="admin@giustup.it">
      <input type="hidden" name="totale" :value="utente.corrispettivo">
      <input type="hidden" name="pec" :value="utente.pec">
      <b-button type="submit" variant="primary">Emetti fattura</b-button>
    </form>
    
  </div>
</template>

<script>
import services from '../../services/service.js'


export default {
  name: 'utente',
  data () {
    return {
        utente: {
            nome: '',
            cognome: '',
            pec: '',
            emailUtente: '',
            denominazione: '',
            indirizzo: '',
            citta: '',
            cap: '',
            provincia: '',
            emailPagante: '',
            codFiscPagante: '',
            piva: '',
            corrispettivo: '',
            dataScadenza: '',
            codiceUfficio: '',
            fatturaDaEmettere: false,
        }
    }
  },
  methods: {
    getData() {
        let userId = this.$route.params.userId;
        services.execute('get', 'utente/admin/' + userId).then((data) => {
          this.utente = data;
        });
    },
    rinnova() {
        let userId = this.$route.params.userId;
        let url = 'utente/admin/' + userId + '/fattura';
        services.execute('post', url, undefined, true).then((resp) => {
          if(resp.status === 200){
            this.getData();
          }
          else{
            alert("Errore estensione data scadenza!");
          }
        });
    }, 
    fattura() {

    }
  },
  mounted() {
    this.getData();

    this.$parent._data.loaded = true;
  }
}
</script>

<style>
.utente {
    text-align: center;
    padding-left: 20%;
    padding-right: 20%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/RinnovaAbbonamento.vue